import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import TagManager from "react-gtm-module";
import cookies from '../../utils/cookies';

const AnalyticsProvider = () => {
  const location = useLocation();
  const settings = useSettingsContext();
  const gtmInitialized = useRef(false);

  useEffect(() => {
    if (settings?.analytics?.gtmKey && !gtmInitialized.current) {
      TagManager.initialize({ gtmId: settings.analytics.gtmKey });
      gtmInitialized.current = true;
    }
  }, [settings]);

  useEffect(() => {
    try {
      cookies.updateStatisticScripts(settings);
      cookies.updateMarketingScripts(settings);
    } catch (error) {
      console.debug('Analytics tracking error:', error);
    }
  }, [location, settings]);

  return null;
};

export default AnalyticsProvider;